import { SelectOption } from '../types/angular-primeng-api';

/**
 * Returns the code of the first select option with the given code or the first code if no option is found.
 * This method is basically a checker to ensure that code is a valid option, otherwise it returns a valid option (the first one).
 * @param selectOptions The select options to search in
 * @param code The code to search for
 * @returns The code itself or the code of the first option or undefined in case of an empty options array
 */
export function getSelectOptionValueOrFirst<TCode extends string>(
    selectOptions: SelectOption<TCode>[],
    code: TCode | undefined,
): TCode | undefined {
    const found = selectOptions.find((l) => l.code === code);
    if (found) {
        return found.code;
    }
    if (selectOptions.length > 0) {
        return selectOptions[0].code;
    }
    console.warn('getSelectOptionValueOrFirst() called with empty select option values');
    return undefined;
}
